import HTTPService    from "@/js/Shared/Services/HTTP/HTTPService";
import SAPOMailConfig from "@/SAPOMailConfig";

export {KidsHTTPService as default};

/**
 * @description Class responsible for managing
 * HTTP services for KidsController
 *
 * @author rsommerfeld <roni.s.sommerfeld@altice.pt>
 *
 * @since 7.0.0
 *
 * @private
 */
class KidsHTTPService {
  /**
   * Filters Endpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.imp;

  /**
   * Check whether email or phone number is account valid
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} account_alias
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async submitAlias(account_alias) {
    const request = {
      op: 'submitAlias',
      alias: account_alias
    };

    return await HTTPService.post(`${this.endpoint}/kidsAuth`, request, 'submit_alias_');
  }

   /**
   * Check whether secret and account are account valid
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} account_alias
   * @param {String} secret
   * @param {String} type_validation
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
   async submitSecret(account_alias, secret, type_validation) {
    const request = {
      op: 'submitSecret',
      alias: account_alias,
      secret: secret,
      type: type_validation
    };

    return await HTTPService.post(`${this.endpoint}/kidsAuth`, request, 'submit_secret');
  }

  /**
   * Update kids definitions in backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} action
   * @param {Number} active
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async updateDefinitions(action, active) {
    const request = {
      op: 'updatePrefs',
      action: action,
      active: active
    };

    return await HTTPService.post(`${this.endpoint}/kidsPrefs`, request, 'update_definitions');
  }

  /**
   * Add address from whitelist from kids definitions
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} address
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async addToWhitelist(address) {
    const request = {
      op: 'addToWhitelist',
      address: address
    };

    return await HTTPService.post(`${this.endpoint}/kidsPrefs`, request, 'add_email_whitelist');
  }

  /**
   * Remove address from whitelist from kids definitions
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} address
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async removeFromWhitelist(address) {
    const request = {
      op: 'removeFromWhitelist',
      address: address
    };

    return await HTTPService.post(`${this.endpoint}/kidsPrefs`, request, 'remove_email_whitelist');
  }

  /**
   * Fetches all kids definitions from the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async getAllDefinitions() {
    return await HTTPService.post(`${this.endpoint}/kidsPrefs`, {
      op: 'getFullPrefs'
    });
  }
}